import styled from 'styled-components';
import { BodySmallMedium } from '../../../../components/typography/styled';
import { statusColor } from '../../../../utils/statusColor';
type ActiveProp = {
  status?:string,
}
export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  min-width: 0;
  padding: 10px 30px 30px 30px;
  box-sizing: border-box;
  position: relative;

  .react-loading-skeleton {
    max-width: 100%;
  }

  @media screen and (max-width: 768px) {
    padding: 10px 16px 30px;
  }
`

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  gap:10px;
`

export const RowHeaderComponent = styled.div`
  display: flex;
  flex-direction: row;
  justify-content:space-between;
  width:100%;
  min-width: 0;
  gap: 10px;

  > :first-child {
    min-width: 0;
    overflow-wrap: anywhere;
    word-break: break-word;
  }
`

export const RightSideComponent = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
  flex-shrink: 0;

`

export const StatusDot = styled.div<ActiveProp>`
  width:12px;
  height:12px;
  background-color: ${({status}) => statusColor(status)};
  border-radius: 100%;
`
export const StatusText = styled(BodySmallMedium)<ActiveProp>`
  color:${({status}) => statusColor(status)};
  margin-left: 6px;
  margin-right: 5px;
  text-transform:capitalize;
`

export const StatusContainer = styled.div`
  display: flex;
  flex-direction:row;
  align-items:center;
`

export const ServiceBody = styled.div`
  padding-top:20px;
  display: flex;
  flex-direction:column;
  align-items:flex-start;
  width: 100%;
  min-width: 0;
  /* box-sizing: border-box; */
  gap:10px;
`
export const TopInfoWrapper = styled.div`
  display: flex;
  width: 100%;
  min-width: 0;
  flex-direction: row;
  /* flex-wrap: wrap; */
  gap: 10px;

  @media screen and (max-width: 768px) {
    flex-direction: column;

    > * {
      width: 100%;
      flex-basis: auto !important;
    }
  }
`

export const BodyWrapper = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  /* justify-content: space-between; */
  flex-wrap: wrap;
  min-width: 0;
  /* margin-top: 10px; */
  gap:10px;

  @media screen and (max-width: 768px) {
    flex-direction: column;

    > * {
      width: 100%;
      flex-basis: auto !important;
    }
  }
`
